import { render, staticRenderFns } from "./checkerboardLayoutDetails.vue?vue&type=template&id=5ea0b3f6&"
import script from "./checkerboardLayoutDetails.vue?vue&type=script&lang=js&"
export * from "./checkerboardLayoutDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports